import { useLocation, useNavigate } from 'react-router-dom'
import { isLocalized, localeFromPath, localizedPath } from '@/i18n/locale'

/**
 * RU | EN переключатель для хедера. Навигирует на ту же страницу в другой
 * локали (/services/x ↔ /en/services/x), сохраняя раздел. SPA-переход через
 * router — мгновенно, без перезагрузки.
 *
 * compact — вариант для мобильного меню (крупнее тап-таргет).
 */
export function LanguageToggle({ compact = false }: { compact?: boolean }) {
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const locale = localeFromPath(pathname)

  // Показываем только там, где английская версия реально готова —
  // иначе клик увёл бы на несуществующий/полу-переведённый /en-путь.
  if (!isLocalized(pathname)) return null

  const go = (target: 'ru' | 'en') => {
    if (target === locale) return
    navigate({ pathname: localizedPath(pathname, target), search })
  }

  const base =
    'text-small font-medium transition-colors tabular-nums select-none'
  const active = 'text-ink'
  const inactive = 'text-muted hover:text-ink'

  return (
    <div
      className={`inline-flex items-center gap-1 ${compact ? 'text-body' : ''}`}
      role="group"
      aria-label="Language / Язык"
    >
      <button
        type="button"
        onClick={() => go('ru')}
        aria-pressed={locale === 'ru'}
        className={`${base} ${locale === 'ru' ? active : inactive}`}
      >
        RU
      </button>
      <span aria-hidden className="text-divider">/</span>
      <button
        type="button"
        onClick={() => go('en')}
        aria-pressed={locale === 'en'}
        className={`${base} ${locale === 'en' ? active : inactive}`}
      >
        EN
      </button>
    </div>
  )
}
